import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Moment from "moment";
import { constants, getFormattedEventDate } from "@qgiv/core-js";
import { EventDateAndLocation } from "@qgiv/core-donor";
import { selectAllP2pSettings } from "../../../../redux/slices/p2pSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../../redux/slices/cmsSettingsSlice";

const ConnectedEventDateAndLocation = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const p2pSettings = useSelector(selectAllP2pSettings);
    const { startDate, endDate, timezone } = p2pSettings;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { displayEventDate = 0 },
    } = control;

    const formattedDateString = getFormattedEventDate({
        startDate,
        endDate,
        timezone,
    });

    const momentStartDate = Moment(startDate);
    const momentEndDate = Moment(endDate);
    const isSameDay = momentStartDate.isSame(momentEndDate, "day");
    const hasStartDate = momentStartDate.isValid();
    const hasEndDate = momentEndDate.isValid() && !isSameDay;
    const hasDate = hasStartDate || hasEndDate;

    const eventDateAndLocationProps = {
        displayEventDateAndLocation: !!Number(displayEventDate),
        displayFormattedEventDateString: hasDate,
        displayFormattedEventLocationString: false,
        displaySeparatorDot: false,
        formattedEventDateString: formattedDateString,
        formattedEventLocationString: "",
    };

    return <EventDateAndLocation {...eventDateAndLocationProps} />;
};

ConnectedEventDateAndLocation.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedEventDateAndLocation;
